import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  // 商户列表
  {
    path: '/companyList/index',
    name: 'companyListIndex',
    component: () => import('@/sub-app/companyList/pages/index.vue'),
    meta: {
      title: '入驻商户',
      keepAlive: false,
    },
  },
  // 商户详情
  {
    path: '/companyList/companyInfo',
    name: 'companyListCompanyInfo',
    component: () => import('@/sub-app/companyList/pages/companyInfo.vue'),
    meta: {
      title: '商户详情',
      keepAlive: false,
    },
  },
  // 商户搜索
  {
    path: '/companyList/companySearch',
    name: 'companyListCompanySearch',
    component: () => import('@/sub-app/companyList/pages/companySearch.vue'),
    meta: {
      title: '商户详情',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  document.title = to.meta?.title || '';
  next();
});

export default router;
